import addAttachmentDataProviderRequest from 'owa-service/lib/factory/addAttachmentDataProviderRequest';
import addNewAttachmentDataProviderOperation from 'owa-service/lib/operation/addNewAttachmentDataProviderOperation';
export default function addFileProvider(providerType, authCode, redirectUrl, updateProvider) {
    if (updateProvider === void 0) { updateProvider = false; }
    var request = addAttachmentDataProviderRequest({
        ProviderType: providerType,
        DataProviderAuthCode: authCode,
        RedirectUrl: redirectUrl,
        IsUpdate: updateProvider,
    });
    return addNewAttachmentDataProviderOperation(request);
}
//# sourceMappingURL=addFileProvider.js.map